// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_nn5Ai","news":"index_news_BfGdq","time":"index_time_LcGOI","title":"index_title_gIEBh"};